import states from "@Utils/states";
import React, { useState } from "react";
import styles from "../styles.module.scss";

interface CountySelectProps {
  state: string;
  county: string | null | undefined;
  onSelect: (stateId: string | null) => void;
  className?: string;
  allAvailableCounties?: string[];
}

const CountySelect: React.FC<CountySelectProps> = ({
  onSelect,
  className,
  county,
  state,
  allAvailableCounties,
}) => {
  const [selectedCounty, setSelectedCounty] = useState<string | null>(
    "All Counties"
  );
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSelect = () => {
    if (selectedCounty === "All Counties") onSelect(null);
    else onSelect(selectedCounty);
    setIsOpen(false);
  };

  const getDisplayText = () => {
    const selectedCounty = states[state].counties?.find((c) => c === county);
    return county ? selectedCounty : "All Counties";
  };

  return (
    <div className={`${styles.selectContainer} ${className || ""}`}>
      <div className={styles.selectButton} onClick={() => setIsOpen(!isOpen)}>
        <span>{getDisplayText()}</span>
        <svg
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ transform: isOpen ? "rotate(180deg)" : "none" }}
        >
          <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" />
        </svg>
      </div>

      {isOpen && (
        <div className={styles.dropdown}>
          <div className={styles.dropdownHeader}>
            <div className={styles.yearSelect}>
              <label>County</label>
              <select
                value={selectedCounty ?? "Select County"}
                onChange={(e) => setSelectedCounty(e.target.value)}
              >
                <option value="All Counties">All Counties</option>

                {(allAvailableCounties || states[state]?.counties || []).map(
                  (county) => (
                    <option key={county} value={county}>
                      {county}
                    </option>
                  )
                )}
              </select>
            </div>
          </div>

          <div className={styles.dropdownFooter}>
            <button
              className={styles.cancelButton}
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </button>
            <button className={styles.applyButton} onClick={handleSelect}>
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CountySelect;
